export default __webpack_public_path__ + "static/media/bhojpuri_cf_2.87de4f31.mp3";